import React from 'react';
import { Input, Button, Upload } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

// import SharedFileSelectorDialog from "../../../disk/SharedFileSelectorDialog";

export default class ImageEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({ value: this.simplifyValue(e.target.value) });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ value: this.simplifyValue(this.props.source.value) });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ value: this.simplifyValue(this.props.source.value) });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ value: this.simplifyValue(nextProps.source.value) });
    }

    simplifyValue(val) {

        if (!val)
            return null;
        if (val.length <= 1000)
            return val;

        return val.substring(0, 1000) + "...";
    }

    onUpload(e) {

        var reader = new FileReader();
        reader.onload = (e) => {
            this.props.source.value = e.target.result;
            this.setState({ value: this.simplifyValue(e.target.result) });
        }

        reader.readAsDataURL(e.file);
    }

    onClick(e) {
        this.setState({
            dlgVisible: true
        })
    }


    hideDialog() {
        this.setState({
            dlgVisible: false
        })
    }

    onSuccess(e) {
        this.props.source.value = e;
        this.setState({ value: this.simplifyValue(e) });
        this.hideDialog();
    }

    render() {

        return (
            <Input className="image-editor" addonAfter={(
                <div style={{ height: 30 }}>
                    <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector" onClick={e => this.onClick(e)} >
                        <SvgIconText type="#anticon-folder5" />

                    </Button>
                    {/* <SharedFileSelectorDialog
                        visible={this.state.dlgVisible}
                        onSuccess={c => this.onSuccess(c)}
                        onCancel={() => { this.hideDialog() }} /> */}
                </div>
            )} value={this.state.value} onChange={e => this.onChange(e)} placeholder={this.props.source.placeholder || ""} />
        );
    }
}

PropertyGridUtils.register("image", (source, propertyGrid) => <ImageEditor source={source} propertyGrid={propertyGrid} />);